import { useQuery } from '@tanstack/react-query';
import { GeogroupService } from '../services';
import { queryKeys } from './query-keys';
async function fetchAllChallengeLeaderboard(challengeId, pageSize) {
  const allItems = [];
  let page = 1;
  let hasMore = true;
  while (hasMore) {
    const {
      leaderboard,
      hasMore: nextHasMore
    } = await GeogroupService.getChallengeLeaderboard(challengeId, {
      page,
      pageSize
    });
    allItems.push(...leaderboard);
    hasMore = nextHasMore;
    page += 1;
  }
  return allItems;
}
function useChallengeLeaderboardAllQuery(challengeId, pageSize = 100) {
  return useQuery({
    queryKey: queryKeys.challengeLeaderboardAll.all(challengeId),
    queryFn: () => fetchAllChallengeLeaderboard(challengeId, pageSize),
    enabled: challengeId !== undefined,
    staleTime: Infinity
  });
}
export default useChallengeLeaderboardAllQuery;